
export const states = [
    { value: "alabama", label: "Alabama" },
    { value: "alaska", label: "Alaska" },
    { value: "arizona", label: "Arizona" },
    { value: "arkansas", label: "Arkansas" },
    { value: "california", label: "California" },
    { value: "colorado", label: "Colorado" },
    { value: "connecticut", label: "Connecticut" },
    { value: "delaware", label: "Delaware" },
    { value: "florida", label: "Florida" },
    { value: "georgia", label: "Georgia" },
    { value: "hawaii", label: "Hawaii" },
    { value: "idaho", label: "Idaho" },
    { value: "illinois", label: "Illinois" },
    { value: "indiana", label: "Indiana" },
    { value: "iowa", label: "Iowa" },
    { value: "kansas", label: "Kansas" },
    { value: "kentucky", label: "Kentucky" },
    { value: "louisiana", label: "Louisiana" },
    { value: "maine", label: "Maine" },
    { value: "maryland", label: "Maryland" },
    { value: "massachusetts", label: "Massachusetts" },
    { value: "michigan", label: "Michigan" },
    { value: "minnesota", label: "Minnesota" },
    { value: "mississippi", label: "Mississippi" },
    { value: "missouri", label: "Missouri" },
    { value: "montana", label: "Montana" },
    { value: "nebraska", label: "Nebraska" },
    { value: "nevada", label: "Nevada" },
    { value: "new_hampshire", label: "New Hampshire" },
    { value: "new_jersey", label: "New Jersey" },
    { value: "new_mexico", label: "New Mexico" },
    { value: "new_york", label: "New York" },
    { value: "north_carolina", label: "North Carolina" },
    { value: "north_dakota", label: "North Dakota" },
    { value: "ohio", label: "Ohio" },
    { value: "oklahoma", label: "Oklahoma" },
    { value: "oregon", label: "Oregon" },
    { value: "pennsylvania", label: "Pennsylvania" },
    { value: "rhode_island", label: "Rhode Island" },
    { value: "south_carolina", label: "South Carolina" },
    { value: "south_dakota", label: "South Dakota" },
    { value: "tennessee", label: "Tennessee" },
    { value: "texas", label: "Texas" },
    { value: "utah", label: "Utah" },
    { value: "vermont", label: "Vermont" },
    { value: "virginia", label: "Virginia" },
    { value: "washington", label: "Washington" },
    { value: "west_virginia", label: "West Virginia" },
    { value: "wisconsin", label: "Wisconsin" },
    { value: "wyoming", label: "Wyoming" },
  ];

  export const options1 = [
    { value: "", label: "Select" },
    { value: "Auto Mechanic", label: "Auto Mechanic" },
    { value: "Blacksmith", label: "Blacksmith" },
    { value: "Boat Repair Technician", label: "Boat Repair Technician" },
    { value: "Cabinet Maker", label: "Cabinet Maker" },
    { value: "Carpenter", label: "Carpenter" },
    { value: "Cleaning Service", label: "Cleaning Service" },
    { value: "Concrete Contractor", label: "Concrete Contractor" },
    { value: "Countertop Installer", label: "Countertop Installer" },
    { value: "Custom Furniture Maker", label: "Custom Furniture Maker" },
    { value: "Dock Builder", label: "Dock Builder" },
    { value: "Drywall Installer", label: "Drywall Installer" },
    { value: "Electrician", label: "Electrician" },
    { value: "Energy Auditor", label: "Energy Auditor" },
    { value: "EV Charger Installer", label: "EV Charger Installer" },
    { value: "Fabricator", label: "Fabricator" },
    { value: "Fencing Installer", label: "Fencing Installer" },
    { value: "Flooring Specialist", label: "Flooring Specialist" },
    { value: "General Contractor", label: "General Contractor" },
    { value: "Handyperson", label: "Handyperson" },
    { value: "Hardscape Contractor", label: "Hardscape Contractor" },
    { value: "Home Automation Specialist", label: "Home Automation Specialist" },
    { value: "HVAC Specialist", label: "HVAC Specialist" },
    { value: "Insulation Installer", label: "Insulation Installer" },
    { value: "Irrigation Specialist", label: "Irrigation Specialist" },
    { value: "Junk Removal Service", label: "Junk Removal Service" },
    { value: "Landscaper", label: "Landscaper" },
    { value: "Lawn Care Professional", label: "Lawn Care Professional" },
    { value: "Marine Electrician", label: "Marine Electrician" },
    { value: "Masonry", label: "Masonry" },
    { value: "Metalworker", label: "Metalworker" },
    { value: "Painter", label: "Painter" },
    { value: "Pest Control Technician", label: "Pest Control Technician" },
    { value: "Plumber", label: "Plumber" },
    { value: "Pool Maintenance Specialist", label: "Pool Maintenance Specialist" },
    { value: "Remodeler", label: "Remodeler" },
    { value: "Roofer", label: "Roofer" },
    { value: "Smart Home Installer", label: "Smart Home Installer" },
    { value: "Snow Removal Contractor", label: "Snow Removal Contractor" },
    { value: "Solar Panel Installer", label: "Solar Panel Installer" },
    { value: "Stonemason", label: "Stonemason" },
    { value: "Stucco Contractor", label: "Stucco Contractor" },
    { value: "Tile Installer", label: "Tile Installer" },
    { value: "Tree Service Provider", label: "Tree Service Provider" },
    { value: "Wallpaper Installer", label: "Wallpaper Installer" },
    { value: "Welder", label: "Welder" },
    { value: "Window and Door Installer", label: "Window and Door Installer" },
    { value: "Woodworker", label: "Woodworker" },
    { value: "Other", label: "Other" }
  ];

  export const options2 = [
    { value: "", label: "Select" },
    { value: "Finding employees", label: "Finding employees" },
    { value: "Managing finances", label: "Managing finances" },
    { value: "Meeting compliance deadlines", label: "Meeting compliance deadlines" },
    { value: "Understanding taxes", label: "Understanding taxes" },
    { value: "Organizing daily operations", label: "Organizing daily operations" },
    { value: "Marketing and growing the business", label: "Marketing and growing the business" },
    { value: "Other", label: "Other" },
  ];

  export const options3 = [
    { value: "", label: "Select" },
    { value: "Business formation", label: "Business formation" },
    { value: "Taxes", label: "Taxes" },
    { value: "Payroll", label: "Payroll" },
    { value: "Compliance", label: "Compliance" },
    { value: "Organization", label: "Organization" },
    { value: "Getting help from trusted professionals", label: "Getting help from trusted professionals" },
    { value: "Other", label: "Other" },
  ];

  export const prfx = [
    { value: '', label: 'Select' },
    { value: 'Mr.', label: 'Mr.' },
    { value: 'Mrs.', label: 'Mrs.' },
    { value: 'Dr.', label: 'Dr.' }
  ];

  export const sfx = [
    { value: '', label: 'Select' },
    { value: 'Jr.', label: 'Jr.' },
    { value: 'Sr.', label: 'Sr.' },
    { value: 'None', label: 'None' },
  ];
  